export enum UserPermissions {
  // Admin Permissions
  ADMIN_ALL = '*',
  BOOK_READ = 'book.read',
  BOOK_CREATE = 'book.create',
  BOOK_DELETE = 'book.delete',
  BOOK_UPDATE = 'book.update',
  BOOK_ACCESS_MANAGE = 'book.access.manage',
  PROFILE_READ = 'profile.read',
  PROFILE_UPDATE = 'profile.update',
  USER_CREATE = 'user.create',
  USER_DELETE = 'user.delete',
  USER_UPDATE = 'user.update',
  USER_READ = 'user.read',
  PAGE_READ = 'page.read',
  PAGE_CREATE = 'page.create',
  PAGE_DELETE = 'page.delete',
  PAGE_UPDATE = 'page.update',
  CHAPTER_FULL = 'chapter.full',
  PAGE_FULL = 'page.full',
  CHAPTER_READ = 'chapter.read',
  CHAPTER_CREATE = 'chapter.create',
  CHAPTER_DELETE = 'chapter.delete',
  CHAPTER_UPDATE = 'chapter.update',
  LAYOUT_READ = 'layout.read',
  LAYOUT_CREATE = 'layout.create',
  LAYOUT_DELETE = 'layout.delete',
  LAYOUT_UPDATE = 'layout.update',
  TRANSLATION_READ = 'translation.read',
  TRANSLATION_CREATE = 'translation.create',
  TRANSLATION_UPDATE = 'translation.update',
  TRANSLATION_DELETE = 'translation.delete',
  ORDER_VIEW_ALL = 'order.viewall',
  REPORT_READ = 'report.read',
  USERREPORT_READ = 'userreport.read',
  ORGANIZATION_READ = 'organization.read',
  ORGANIZATION_MANAGE = 'organization.manage',
}
